export default (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-download"></i><div>${label}</div>`,
    category: category,
    content: `<button data-gjs-type="export-button" type="submit" class="btn btn-sm btn-success mb-2 mr-0" value="export">Download CSV</button>`,
  });
};
